import React, { Component } from "react";
import axios from "axios";
import { Button, Form, Dropdown, Grid, TextArea, Input, Icon } from 'semantic-ui-react'
import { RSA_NO_PADDING } from "constants";

const url = "https://encontech.azurewebsites.net/api/jobs";
const uploadUrl = 'https://encontech.azurewebsites.net/api/file';

//const url = "http://localhost:5000/api/jobs";
//const uploadUrl = 'http://localhost:5000/api/file';

interface JobDropDown {
  id: number;
  value: number;
  text: string;
  description: string;
}

type JobState =
{
  jobData: Array<JobDropDown>,
  selectValue: number,
  name : string,
  link: string,
  address: string,
  brand: string,
  version: string,
  contractStartDate: string,
  contractEndDate: string,
  comments: string,
  alarmFormGuid: string,
  alarmFormFileName: string,
  showAlarmFileDownloadLink: boolean
};

class AdminUpdateJob extends React.Component<{}, JobState> {
  constructor(props: any) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      jobData: new Array<JobDropDown>(),
      selectValue:0,
      name :"",
      link: "",
      address: "",
      brand: "",
      version: "",
      contractStartDate: "",
      contractEndDate: "",
      comments: "",
      alarmFormGuid: "",
      alarmFormFileName: "",
      showAlarmFileDownloadLink: false
    };

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleLinkChange = this.handleLinkChange.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
    this.handleContractStartDateChange = this.handleContractStartDateChange.bind(this);
    this.handleContractEndDateChange = this.handleContractEndDateChange.bind(this);
    this.handleCommentsChange = this.handleCommentsChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAlarmFormUpdateClick = this.handleAlarmFormUpdateClick.bind(this);
  }
  
  fileInput : any;

  handleNameChange(e:any) {
    this.setState({ name: e.target.value });
  }
  handleLinkChange(e:any) {
    this.setState({ link: e.target.value });
  }
  handleAddressChange(e:any) {
    this.setState({ address: e.target.value });
  }
  handleBrandChange(e:any) {
    this.setState({ brand: e.target.value });
  }
  handleVersionChange(e:any) {
    this.setState({ version: e.target.value });
  }
  handleContractStartDateChange(e:any) {
    this.setState({ contractStartDate: e.target.value });
  }
  handleContractEndDateChange(e:any) {
    this.setState({ contractEndDate: e.target.value});
  }
  handleCommentsChange(e:any) {
    this.setState({ comments: e.target.value });
  }
  handleAlarmFormUpdateClick(e:any){
    this.setState({showAlarmFileDownloadLink: false });
    e.preventDefault(); 
  }

  handleSubmit(e: any ) {
    console.log(this.state.name);
    console.log(this.state.link);
    console.log(this.state.address);
    console.log(this.state.brand);
    console.log(this.state.version);
    console.log(true);
    console.log(this.state.contractStartDate);
    console.log(this.state.contractEndDate);
    console.log(this.state.comments);

    const formData = new FormData();
    formData.append("files", this.fileInput.current.files[0]);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    axios
    .post(uploadUrl, formData, config)
    .then((response) => {
      console.log(response.data);
      var af = { fileGuid: response.data.guid, fileName: response.data.file };

      console.log("AF:" + af);
    axios
    .put(url+ "/" + this.state.selectValue,
      {
        "id": this.state.selectValue,
        "name": this.state.name,
        "link": this.state.link,
        "address": this.state.address,
        "brand": this.state.brand,
        "version": this.state.version,
        "contract": true,
        "contractStartDate": this.state.contractStartDate,
        "contractEndDate": this.state.contractEndDate,
        "contractExpirationDate": this.state.contractEndDate,
        "alarmFormFile": af,
        "comments": this.state.comments
    } )
/*    .then(res => {
      this.setState({
        name :"",
        link: "",
        address: "",
        brand: "",
        version: "",
        contractStartDate: "",
        contractEndDate: "",
        comments: "",
        alarmForm: ""
      });
    })*/
    .catch(err => {
      console.log(err);
    });
 })
      .catch((err) => {
        console.log(err);
      }); 
    e.preventDefault(); 
    
  }

  
  componentDidMount() {

    axios.get(url).then((response) => {

      var updateJobList = response.data.map((x:any) => {
        return  { key: x.id, value: x.id, text: x.name, description: x.address}
      });

      this.setState({
        jobData: updateJobList,
      });

    });
  }


  handleChange = (e:any, { value }: any ) => {
    console.log(value);
    this.setState({ selectValue:value });

    axios
    .get(url+ "/" + value)
    .then(res => {
      console.log("name: " + res.data.name);
      var contractEndDate = new Date(res.data.contractEndDate);
      var contractStartDate = new Date(res.data.contractStartDate);
      this.setState({
        name: res.data.name,
        link: res.data.link,
        address: res.data.address,
        brand: res.data.brand,
        version: res.data.version,
        contractStartDate: contractStartDate.toISOString().split('T')[0] ,
        contractEndDate: contractEndDate.toISOString().split('T')[0] ,
        comments: res.data.comments
      });

      

      var alarmFormFile = res.data.alarmFormFile;
      if(alarmFormFile != null)
      {
        //Show the link and make the download available
        console.log("I AM IN THIS CODE BLOCK  ");
        this.setState({alarmFormGuid: res.data.alarmFormFile.fileGuid });
        this.setState({alarmFormFileName: res.data.alarmFormFile.fileName });
        this.setState({showAlarmFileDownloadLink: true });
      }
      else{
        this.setState({showAlarmFileDownloadLink: false });
      }

    })
    .catch(err => {
      console.log(err);
    }); 

  }

  selectJob = (e: any) => {
    console.log("update job: " + this.state.selectValue)
    axios
    .get(url+ "/" + this.state.selectValue)
    .then(res => {
      console.log("name: " + res.data.name);
      this.setState({
        name: res.data.name 
      });
    })
    .catch(err => {
      console.log(err);
    }); 

    this.setState({
      jobData: this.state.jobData.filter( (x:JobDropDown) => { return x.value != this.state.selectValue})
    });
  }

  render() {
    return (
    <div style={{ height:"500px" }}>
        <h1>Admin (Update Job Site)</h1>
        <Grid columns={2} padded>
        <Grid.Row>
            <Grid.Column width={14}>
            <Dropdown
              placeholder='Select Job Site to Update..'
              fluid
              search
              selection
              options={this.state.jobData}
              value={this.state.selectValue} 
              onChange={this.handleChange.bind(this)} 
            />
            </Grid.Column>
            <Grid.Column width={2}>
            <Button type='submit' value="Submit" onClick={this.handleSubmit.bind(this)} primary>Submit</Button>

            </Grid.Column>
        </Grid.Row>
    </Grid>

        <Form onSubmit={this.handleSubmit}>
    <Grid columns={2} divided padded>
        <Grid.Row>
            <Grid.Column>
                <Form.Field>
                <label>Name</label>
                <input type="text" value={this.state.name} onChange={this.handleNameChange} />
                </Form.Field>
                <Form.Field>
                <label>Link</label>
                <Input type="text" value={this.state.link} onChange={this.handleLinkChange}/>
            </Form.Field>
            <Form.Field>
                <label>Address</label>
                <input type="text" value={this.state.address} onChange={this.handleAddressChange} />
            </Form.Field>
            <Form.Field>
                <label>Brand</label>
                <input  type="text" value={this.state.brand} onChange={this.handleBrandChange}/>
            </Form.Field>
            <Form.Field>
                <label>Version</label>
                <input  type="text" value={this.state.version} onChange={this.handleVersionChange}/>
            </Form.Field>
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
        <label>Contract Start Date</label>
        <input type="date" value={this.state.contractStartDate} onChange={this.handleContractStartDateChange}/>
      </Form.Field>
      <Form.Field>
        <label>Contract End Date</label>
        <input type="date"  value={this.state.contractEndDate} onChange={this.handleContractEndDateChange}/>
      </Form.Field>
      <Form.Field>
        <label>Comments</label>
        <TextArea placeholder='Additional Information' style={{ minHeight: 110 }} type="text" value={this.state.comments} onChange={this.handleCommentsChange}/>
      </Form.Field>
      <Form.Field>
        <label>Alarm Form</label>
        <input type="file" ref={this.fileInput} hidden={ this.state.showAlarmFileDownloadLink } />
        <Button hidden={!this.state.showAlarmFileDownloadLink} circular onClick={this.handleAlarmFormUpdateClick}>Update</Button>
        <a href= {uploadUrl + "/" + this.state.alarmFormGuid} hidden={!this.state.showAlarmFileDownloadLink} >{this.state.alarmFormFileName}</a>
        
      </Form.Field>
            </Grid.Column>
        </Grid.Row>
    </Grid>

    </Form>
    </div>
  )}}
  
  export default AdminUpdateJob